"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    expressDealHotelId: ()=>expressDealHotelId,
    useSetHotelPinOnMapHook: ()=>useSetHotelPinOnMapHook
});
const external_react_namespaceObject = require("react");
const products_js_namespaceObject = require("../constants/products.js");
const buildHotelDetailURL_js_namespaceObject = require("./HotelListingCard/buildHotelDetailURL.js");
const MetadataManager_js_namespaceObject = require("../components/MarkdownComponent/MetadataManager.js");
const expressDealHotelId = (hotel)=>{
    if (!hotel || 'object' != typeof hotel) return '';
    const neighborhoodName = hotel.location?.neighborhoodName;
    if (hotel.sopqDealName && neighborhoodName) return `${hotel.sopqDealName}-${neighborhoodName}-${hotel.ratesSummary?.grandTotal}`;
    return '';
};
const useSetHotelPinOnMapHook = ({ displayResult, args, displaySopqOnly })=>{
    (0, external_react_namespaceObject.useEffect)(()=>{
        const availableNames = MetadataManager_js_namespaceObject.inlineMetadataManager.getHotelOnMapList()?.map((p)=>p?.name)?.join(',');
        const newNames = displayResult?.map((h)=>h?.name || 'hotel')?.join(',');
        if (availableNames !== newNames) {
            const hotelLocationList = displayResult?.filter((hotel)=>hotel.location && hotel.location.latitude && hotel.location.longitude)?.map((hotel)=>({
                    type: products_js_namespaceObject.mapPinType.HOTEL,
                    name: hotel?.name || 'hotel',
                    description: hotel?.description,
                    location: hotel.location,
                    lat: hotel.location.latitude,
                    lng: hotel.location.longitude,
                    hotelDetailURL: (0, buildHotelDetailURL_js_namespaceObject.buildHotelDetailURL)(args, hotel),
                    hotel
                }));
            MetadataManager_js_namespaceObject.inlineMetadataManager.setHotelPinOnMap(hotelLocationList);
        }
    }, [
        displaySopqOnly,
        displayResult,
        args
    ]);
};
exports.expressDealHotelId = __webpack_exports__.expressDealHotelId;
exports.useSetHotelPinOnMapHook = __webpack_exports__.useSetHotelPinOnMapHook;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "expressDealHotelId",
    "useSetHotelPinOnMapHook"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
